// src/components/E2EEImage.jsx
import React, { useState, useEffect } from 'react';
import { decryptFile } from '../services/signalSession';

export default function E2EEImage({
  fileData,
  senderId,
  currentUserId,
  fileId,
  onLoad,
  onClick,
  style,
  alt
}) {
  const [imageUrl, setImageUrl] = useState(null);
  const [failed, setFailed] = useState(false); // 🆕 remplace error

  useEffect(() => {
    if (!fileData || !senderId || !currentUserId) {
      console.error('❌ E2EEImage : données manquantes', { fileData, senderId, currentUserId });
      setFailed(true);
      return;
    }

    let objectUrl;

    async function loadImage() {
      try {
        const decrypted = await decryptFile(fileData, senderId, currentUserId, fileId);

        if (!decrypted || (decrypted.byteLength === 0 && decrypted.length === 0)) {
          throw new Error('Fichier déchiffré vide');
        }

        const mimeType = fileData.mimeType || 'image/png';
        const blob = new Blob([decrypted], { type: mimeType });

        if (blob.size === 0) {
          throw new Error('Blob vide créé');
        }

        objectUrl = URL.createObjectURL(blob);
        setImageUrl(objectUrl);

      } catch (err) {
        console.error('❌ Erreur déchiffrement image:', fileId, err);
        setFailed(true); // 🆕 plus de message affiché
      }
    }

    loadImage();

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl); // 🆕 bonus : évite une fuite mémoire
    };
  }, [fileData, senderId, currentUserId, fileId]);

  if (failed) {
    return null; // 🆕 rien du tout, comme pour les messages texte
  }
  if (!imageUrl) {
    return <div>Chargement...</div>;
  }

  return (
    <img
      src={imageUrl}
      onLoad={onLoad}
      onClick={onClick}
      style={style}
      alt={alt || fileData?.originalName}
    />
  );
}